export default __webpack_public_path__ + "static/media/excel.fb9e1cf4.jpg";